import StepsBar from './StepsBar.styled';

export default StepsBar;
